import AppClientCredential from "./Credential";
import ContactCredential from "./ContactCredential";

const credentials = { app: AppClientCredential, contact: ContactCredential }

export { AppClientCredential, ContactCredential }
export default credentials;